<template>
<div class="chapter">
<div class="inner_page">
<p class="c6" id="calibre_pb_3"><span class="c4">Acknowledgements</span></p>
<p class="western1">I would like to express my sincere gratitude
to some people who played a part in helping me tell this story and
get it out into the world. First, to my parents, Paul and Theresa,
for their guidance and sacrifices that got me through those
harrowing formative years and whose influence shapes me still. To
Nicki and Sam, whose courage, strength, and love are enduring
inspirations. To my wife, Heather, for her support even on those
lonely nights when she surely wondered why she had committed
herself to such a recluse. To Bruce Watson, teacher and friend, who
instilled in me a deeper appreciation for the art form of
storytelling and who read a very early draft of this novel and held
nothing back. To my other advance readers who saw the things I
couldn't. To Craig DiLouie who offered the advice and guidance to
plant this story's seed in the ground. To Felicia Sullivan, who
revealed my weaknesses to me with her edits. And to the good people
at Permuted Press, especially Michael Wilson and Anthony Ziccardi,
who were willing to take a risk.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_004.vue?c3f2625a